import { render, staticRenderFns } from "./DeliveryPercentageChart.vue?vue&type=template&id=581f3c2f&scoped=true"
import script from "./DeliveryPercentageChart.vue?vue&type=script&lang=js"
export * from "./DeliveryPercentageChart.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPercentageChart.vue?vue&type=style&index=0&id=581f3c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581f3c2f",
  null
  
)

export default component.exports